import {
  Component,
  OnInit,
  EventEmitter,
  Input,
  Output,
  ElementRef,
  ViewChild
} from "@angular/core";
import { NgbDropdown } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-custom-dropdown",
  templateUrl: "./custom-dropdown.component.html",
  styleUrls: ["./custom-dropdown.component.scss"]
})
export class CustomDropdownComponent implements OnInit {
  @Input() freeform;
  @Input() required;
  @Input() value: string;
  @Input() placeholder: string;
  @Input() selectOptions: Array<DropdownOption>;
  @Output() onOptionSelect: EventEmitter<any> = new EventEmitter();

  @ViewChild("otherOption") elem: ElementRef;

  public selectedOption: string;
  public freeformEnabled: boolean;

  constructor() {}

  ngOnInit() {
    this.selectedOption = this.value || null;
    this.freeformEnabled = typeof this.freeform === "string";
  }

  onInput($event) {
    this.onOptionSelect.emit($event.currentTarget.value);
  }

  onDropdownClick($event, dropdown: NgbDropdown) {
    $event.stopPropagation();
    dropdown.open();
  }

  onSelect(option: string) {
    this.selectedOption = option;
    if (this.freeformEnabled && option === "Other") {
      setTimeout(() => {
        this.elem.nativeElement.focus();
      });
    }

    this.onOptionSelect.emit(
      option === "Other" && this.freeformEnabled ? null : option
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/custom-dropdown/custom-dropdown.component.ts